<template>
<div>
  <label class="font-weight-bold d-block mb-2">When do you open?</label>
  <div class="start-choice" :class="{ on: value.mode === 'later' }" @click="set({ mode: 'later' })">
    <b-form-radio :checked="value.mode" value="later" @change="set({ mode: 'later' })">On a date <span class="text-muted small">(card saved now, charged that day)</span></b-form-radio>
    <div v-if="value.mode === 'later'" class="mt-2 ml-4">
      <date-step :value="value.date" :min="min" :max="max" :suggestions="suggestions" @input="set({ date: $event })"></date-step>
    </div>
  </div>
  <div class="start-choice" :class="{ on: value.mode === 'now' }" @click="set({ mode: 'now' })">
    <b-form-radio :checked="value.mode" value="now" @change="set({ mode: 'now' })">Today</b-form-radio>
  </div>
</div>
</template>

<script>
import DateStep from './DateStep.vue'

// "Start today" vs "Start on a date".
export default {
  components: { DateStep },
  props: { value: Object, min: String, max: String, suggestions: Array },
  methods: { set (patch) { this.$emit('input', Object.assign({}, this.value, patch)) } }
}
</script>
